import { useQuery } from '@tanstack/react-query';

import { FIAT_CURRENCIES, FIAT_PRICE_API, FIAT_API_NAME_CONVERSIONS } from 'const';
import { useEffect } from 'react';
import { UsingDevKey } from 'utils/Dev';
import { GetDeepComparedData } from 'utils/Query';
import useGameDetails from './useGameDetails';


function GetPlaceholderFiatRates() {
  const rates = {};
  let supportedFiatTickerSymbol;
  for (let i = 1; i < FIAT_CURRENCIES.length; i++) { // skip the first item, as it's empty by design
    supportedFiatTickerSymbol = FIAT_CURRENCIES[i]['symbol'];
    rates[supportedFiatTickerSymbol] = 1;
  }
  return rates;
}
const placeholderFiatRates = GetPlaceholderFiatRates();



function useFiatRates() {
  const gameDetails = useGameDetails();

  const { status: queryStatus, error: queryError, data: fiatPriceData } = useQuery({
    queryKey: ['fiatPriceData', gameDetails.wantedChain.tickerSymbol],
    queryFn: FetchFiatRates,
    placeholderData: placeholderFiatRates,
    retry: true, // will retry indefinitely
    retryDelay: (attempt) => attempt * 1000,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    cacheTime: 24 * 60 * 60 * 1000,
    structuralSharing: GetDeepComparedData
  });


  useEffect(() => {
    if (queryError)
      ReportQueryError();
  }, [queryError]);


  async function FetchFiatRates() {
    if (!gameDetails.wantedChain.tickerSymbol)
      return placeholderFiatRates;
    const apiCryptoID = FIAT_API_NAME_CONVERSIONS[gameDetails.wantedChain.tickerSymbol];
    const response = await fetch(FIAT_PRICE_API + apiCryptoID, { method: "GET" });
    const data = await response.json();
    if (!data?.market_data?.current_price)
      return placeholderFiatRates;
    else
      return data.market_data.current_price;
  }

  function ReportQueryError() {
    console.error(queryError);
    if (UsingDevKey()) {
      alert('Can\'t fetch fiat exchange rates; See next message for error');
      alert(JSON.stringify(queryError));
    }
  }

  return fiatPriceData;
};

export default useFiatRates;
